const cloneDeep = require('lodash/cloneDeep')

/**
 * List of known PII items to mask
 */
const knownPiiList = ['_csrf', 'business', 'guarantor', 'offer']

/**
 * Masks any keys in the given object which exist in knownPiiList (mutates object)
 *
 * @private
 * @param {object} data
 * @returns {void}
 */
const performMask = (data) => {
  knownPiiList.forEach((piiItem) => {
    if (Object.prototype.hasOwnProperty.call(data, piiItem)) {
      data[piiItem] = '**masked**'
    }
  })
}

/**
 * Mutates input object to mask PII data
 *
 * @param {object} data - input data
 * @returns {void}
 */
const maskPii = (data) => {
  const seen = new WeakSet()

  const maskPiiInternal = (value) => {
    if (typeof value === 'object' && value !== null) {
      if (seen.has(value)) {
        return
      }

      seen.add(value)
    }

    if (value instanceof Array) {
      for (let i = 0; i < value.length; i += 1) {
        maskPiiInternal(value[i])
      }
    } else if (value instanceof Object) {
      performMask(value)

      Object.keys(value).forEach((key) => {
        maskPiiInternal(value[key])
      })
    }
  }

  maskPiiInternal(data)
}

/**
 * Returns a copy of the data with pii masked rather than mutating the original object
 *
 * @param {object} data - input data
 * @returns {object} data with masked pii
 */
const cloneAndMask = (data) => {
  const result = cloneDeep(data)
  maskPii(result)
  return result
}

export { maskPii, cloneAndMask }
